import { $api } from '../y/api';

export type UMediaLinkKind = 'youtube' | 'vimeo' | 'spotify' | 'soundcloud';

export interface UMediaLink {
    kind: UMediaLinkKind;
    url: string;
    args: Record<string, string>;
}

export interface ULinkPreview {
    url: string;
    is_failed: boolean;
    title: string;
    subtitle?: string;
    thumbnail_url: string;
}

export function uMediaLinkParse(url: string) {
    return $api.POST<UMediaLink>(`u/media_link/parse`, { url });
}

export function uMediaLinkPreview(link: UMediaLink) {
    return $api.POST<ULinkPreview>(`u/media_link/preview`, link);
}
